import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    itemsSelector: String,
    filter: String
  }

  connect() {
    if ("URLSearchParams" in window) {
      const checkedValue = this.isChecked() ? "yes" : "no";
      const url = new URL(window.location);
      const paramValue = url.searchParams.get(this.queryParam());
      if (paramValue && checkedValue !== paramValue) {
        this.toggle();
      }
    }
  }

  toggle() {
    this.element.classList.toggle("toggle-checked");
    Array.from(document.getElementsByClassName(this.itemsSelectorValue)).forEach((element) => {
      element.classList.toggle("hidden");
    });

    if ("URLSearchParams" in window) {
      const checkedValue = this.isChecked() ? "yes" : "no";
      const url = new URL(window.location);
      url.searchParams.set(this.queryParam(), checkedValue);
      if (document.getElementById("back")) {
        document.getElementById("back").value = url.pathname + url.search;
      }
      history.pushState(null, "", url);
    }

    this.filterValue.split(" ").forEach((filter) => {
      let elem = document.getElementById(filter);
      if(elem){
        let event = new Event("change");
        elem.dispatchEvent(event);
      }
    })
  }

  queryParam() {
    return `toggle-${this.itemsSelectorValue}`;
  }

  isChecked() {
    return this.element.classList.contains("toggle-checked");
  }
}
